import strings from "./strings";
export const privacyMessagePayload = {
    content: [
        {
            type: "chat_text",
            text: strings.defaultPrivacyMessage
        }
    ],
    layout: {
        selectionMode: "button"
    },
    inputData: {
        choice: {
            visibilityAfterSubmit: "block",
            list: [
                {
                    command: "privacy_ok",
                    content: [
                        {
                            type: "chat_text",
                            text: "Accetto"
                        }
                    ],
                    interaction: {
                        adamActions: [
                            {
                                code: "conversation.chat.enable"
                            }
                        ],
                        action: "single_choice",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_text",
                                text: "Accetto",
                                adamActions: [
                                    {
                                        code: "message.user.privacy_policy",
                                        args: ["choice", "accept"]
                                    }
                                ]
                            }
                        ]
                    }
                },
                {
                    command: "privacy_ko",
                    content: [
                        {
                            type: "chat_text",
                            text: "Rifiuto"
                        }
                    ],
                    interaction: {
                        adamActions: [
                            {
                                code: "conversation.chat.disable"
                            }
                        ],
                        action: "single_choice",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_text",
                                text: "Rifiuto",
                                adamActions: [
                                    {
                                        code: "message.user.privacy_policy",
                                        args: ["choice", "reject"]
                                    }
                                ]
                            }
                        ]
                    }
                }
            ]
        }
    }
};
export const welcomeMessagePayload = {
    content: [
        {
            type: "chat_text",
            text: strings.defaultWfpWelcomeMessage
        }
    ],
    layout: {
        selectionMode: "input"
    }
};
export const restartMessagePayload = {
    text: strings.defaultRestartMessage,
    adamActions: [{
            code: "conversation.session.restart"
        }],
};
export const timeoutMessagePayload = {
    content: [
        {
            type: "chat_text",
            text: strings.defaultTimeoutMessage
        }
    ],
    layout: {
        selectionMode: "button"
    },
    adamActions: [{
            code: "conversation.status.timeout"
        }],
    inputData: {
        choice: {
            visibilityAfterSubmit: "block",
            modeBeforeSubmit: "inputBlock",
            list: [
                {
                    // NOTE: this command is frontend only
                    command: "command.continue_conversation",
                    content: [
                        {
                            type: "chat_text",
                            text: strings.defaultTimeoutContinuePreviousMessage,
                        }
                    ],
                    interaction: {
                        adamActions: [
                            {
                                code: "conversation.chat.enable"
                            }
                        ],
                        action: "single_choice",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_text",
                                text: strings.defaultTimeoutContinuePreviousMessage,
                                adamActions: [
                                    {
                                        // NOTE: this code is frontend only
                                        code: "conversation.session.continue_conversation",
                                    }
                                ]
                            }
                        ]
                    }
                },
                {
                    command: "command.restart",
                    content: [
                        {
                            type: "chat_text",
                            text: strings.defaultTimeoutRestartMessage,
                        }
                    ],
                    interaction: {
                        adamActions: [
                            {
                                code: "conversation.chat.enable"
                            }
                        ],
                        action: "single_choice",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_text",
                                text: strings.defaultTimeoutRestartMessage,
                                adamActions: [
                                    {
                                        code: "conversation.session.restart",
                                    }
                                ]
                            }
                        ]
                    }
                }
            ]
        }
    },
};
export const courtesyMessageNewBubblePayload = {
    content: [
        {
            type: "chat_text",
            text: strings.defaultCourtesyMessageNewBubbleText
        }
    ],
    layout: {
        selectionMode: "button"
    },
    adamActions: [{
            code: "conversation.status.courtesy_message_new_bubble"
        }],
    inputData: {
        choice: {
            visibilityAfterSubmit: "block",
            modeBeforeSubmit: "inputBlock",
            list: [
                {
                    // NOTE: this command is frontend only
                    command: "command.procedural_questions",
                    content: [
                        {
                            type: "chat_text",
                            text: strings.defaultCourtesyMessageNewBubbleButton1Text,
                        }
                    ],
                    interaction: {
                        adamActions: [
                            {
                                code: "conversation.chat.enable"
                            }
                        ],
                        action: "single_choice",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_text",
                                text: strings.defaultCourtesyMessageNewBubbleButton1Text,
                                adamActions: [
                                    {
                                        // NOTE: this code is frontend only
                                        code: "conversation.session.procedural_questions",
                                    }
                                ]
                            }
                        ]
                    }
                },
                {
                    // NOTE: this command is frontend only
                    command: "command.travel_policies",
                    content: [
                        {
                            type: "chat_text",
                            text: strings.defaultCourtesyMessageNewBubbleButton2Text,
                        }
                    ],
                    interaction: {
                        adamActions: [
                            {
                                code: "conversation.chat.enable"
                            }
                        ],
                        action: "single_choice",
                        type: "send_message",
                        content: [
                            {
                                type: "chat_text",
                                text: strings.defaultCourtesyMessageNewBubbleButton2Text,
                                adamActions: [
                                    {
                                        // NOTE: this code is frontend only
                                        code: "conversation.session.travel_policies",
                                    }
                                ]
                            }
                        ]
                    }
                }
            ]
        }
    },
};
export const courtesyMessageNewBubbleButton1ReplyPayload = {
    content: [
        {
            type: "chat_text",
            text: strings.defaultCourtesyMessageNewBubbleButton1ReplyText
        }
    ],
    layout: {
        selectionMode: "input"
    }
};
export const courtesyMessageNewBubbleButton2ReplyPayload = {
    content: [
        {
            type: "chat_text",
            text: strings.defaultCourtesyMessageNewBubbleButton2ReplyText
        }
    ],
    layout: {
        selectionMode: "input"
    }
};
export const dateMessageIncoming = {
    content: [
        {
            type: "chat_html",
            html: "&lt;p&gt;Add your start date testing&lt;/p&gt;",
        },
    ],
    layout: {
        selectionMode: "input",
    },
    inputData: {
        interaction: {
            type: "input_date",
            action: "input_date",
            options: {
                dateType: "date",
                minStartDate: "2025-04-05",
                maxStartDate: "2025-04-30",
            }
        }
    }
};
export const locationMessageIncoming = {
    content: [
        {
            type: "chat_html",
            html: "Inserisci l'indirizzo di riferimento location:"
        }
    ],
    inputData: {
        interaction: {
            type: "insert_location"
        }
    },
    adamActions: [],
};
export const carouselMessageIncoming = {
    "content": [
        {
            "type": "chat_html",
            "html": "&lt;p&gt;Certo! Ecco le migliori offerte che puoi attivare per il tuo viaggio in Europa. Selezionale per saperne di più&lt;/p&gt;"
        }
    ],
    "layout": {
        "selectionMode": "button",
        "location": "in",
        "orientation": "auto"
    },
    "inputData": {
        "choice": {
            "maxSelectable": 1,
            "minSelectable": 1,
            "visibilityAfterSubmit": "hide",
            "modeBeforeSubmit": "inputBlock",
            "list": [
                {
                    "command": "opt_a614480950989",
                    "content": [
                        {
                            "type": "chat_image",
                            "url": "https://xmpp-svil.monksoftware.it/api/v1/attachments/pictures/893fe602d649cdb7612feac8bd82b1ea.png",
                            "filename": "unknown",
                            "caption": "TIM in Viaggio PASS a 19,99 € /30gg"
                        }
                    ],
                    "interaction": {
                        "action": "cmd_step",
                        "type": "send_message",
                        "content": [
                            {
                                "type": "chat_image",
                                "url": "https://xmpp-svil.monksoftware.it/api/v1/attachments/pictures/893fe602d649cdb7612feac8bd82b1ea.png",
                                "filename": "unknown",
                                "caption": "TIM in Viaggio PASS a 19,99 € /30gg"
                            }
                        ]
                    }
                },
                {
                    "command": "opt_caee3a06ece6f",
                    "content": [
                        {
                            "type": "chat_image",
                            "url": "https://xmpp-svil.monksoftware.it/api/v1/attachments/pictures/bb8d93344b48ca6c81fed0608326413e.png",
                            "filename": "unknown",
                            "caption": "TIM in Viaggio PASS a 13,99 € /15gg"
                        }
                    ],
                    "interaction": {
                        "action": "cmd_step",
                        "type": "send_message",
                        "content": [
                            {
                                "type": "chat_image",
                                "url": "https://xmpp-svil.monksoftware.it/api/v1/attachments/pictures/bb8d93344b48ca6c81fed0608326413e.png",
                                "filename": "unknown",
                                "caption": "TIM in Viaggio PASS a 13,99 € /15gg"
                            }
                        ]
                    }
                }
            ]
        }
    },
    "adamActions": [],
};
export const carouselMessageSingleChoiceImage = {
    "content": [
        {
            "type": "chat_html",
            "html": "<p>single choice image</p>"
        }
    ],
    "layout": {
        "selectionMode": "button",
        "location": "in",
        "orientation": "auto"
    },
    "inputData": {
        "choice": {
            "maxSelectable": 1,
            "minSelectable": 1,
            "visibilityAfterSubmit": "hide",
            "modeBeforeSubmit": "inputBlock",
            "list": [
                {
                    "command": "opt_ac4b5924e9393",
                    "content": [
                        {
                            "type": "chat_image",
                            "url": "https://xmpp-svil.monksoftware.it/api/v1/attachments/pictures/729b17725215c20c916cfcfcb6115729.png",
                            "filename": "unknown"
                        }
                    ],
                    "interaction": {
                        "action": "cmd_step",
                        "type": "send_message",
                        "content": [
                            {
                                "type": "chat_image",
                                "url": "https://xmpp-svil.monksoftware.it/api/v1/attachments/pictures/729b17725215c20c916cfcfcb6115729.png",
                                "filename": "unknown"
                            }
                        ]
                    }
                },
                {
                    "command": "opt_cd94457b1a1ce",
                    "content": [
                        {
                            "type": "chat_image",
                            "url": "https://xmpp-svil.monksoftware.it/api/v1/attachments/pictures/2899abfe54875188f3cc60cb560cce22.png",
                            "filename": "unknown"
                        }
                    ],
                    "interaction": {
                        "action": "cmd_step",
                        "type": "send_message",
                        "content": [
                            {
                                "type": "chat_image",
                                "url": "https://xmpp-svil.monksoftware.it/api/v1/attachments/pictures/2899abfe54875188f3cc60cb560cce22.png",
                                "filename": "unknown"
                            }
                        ]
                    }
                }
            ]
        }
    },
    "adamActions": [],
};
export const carouselMessageSingleChoiceImageText = {
    "content": [
        {
            "type": "chat_html",
            "html": "<p>single choice image + text</p>"
        }
    ],
    "layout": {
        "selectionMode": "button",
        "location": "in",
        "orientation": "auto"
    },
    "inputData": {
        "choice": {
            "maxSelectable": 1,
            "minSelectable": 1,
            "visibilityAfterSubmit": "hide",
            "modeBeforeSubmit": "inputBlock",
            "list": [
                {
                    "command": "opt_e0d0de2f21ac2",
                    "content": [
                        {
                            "type": "chat_image",
                            "url": "https://xmpp-svil.monksoftware.it/api/v1/attachments/pictures/a61aa95cf1b83de2227f8cb41ec9c136.png",
                            "filename": "unknown",
                            "caption": "<p>single choice image + text 1</p>"
                        }
                    ],
                    "interaction": {
                        "action": "cmd_step",
                        "type": "send_message",
                        "content": [
                            {
                                "type": "chat_image",
                                "url": "https://xmpp-svil.monksoftware.it/api/v1/attachments/pictures/a61aa95cf1b83de2227f8cb41ec9c136.png",
                                "filename": "unknown",
                                "caption": "<p>single choice image + text 1</p>"
                            }
                        ]
                    }
                },
                {
                    "command": "opt_e2958bf2055b28",
                    "content": [
                        {
                            "type": "chat_image",
                            "url": "https://xmpp-svil.monksoftware.it/api/v1/attachments/pictures/586ced9c6e5c08eed8280ea326a5427a.png",
                            "filename": "unknown",
                            "caption": "<p>single choice image + text 2</p>"
                        }
                    ],
                    "interaction": {
                        "action": "cmd_step",
                        "type": "send_message",
                        "content": [
                            {
                                "type": "chat_image",
                                "url": "https://xmpp-svil.monksoftware.it/api/v1/attachments/pictures/586ced9c6e5c08eed8280ea326a5427a.png",
                                "filename": "unknown",
                                "caption": "<p>single choice image + text 2</p>"
                            }
                        ]
                    }
                }
            ]
        }
    },
    "adamActions": [],
};
export const carouselMessageMultipleChoiceText = {
    "content": [
        {
            "type": "chat_html",
            "html": "<p>multi choice text</p>"
        }
    ],
    "layout": {
        "selectionMode": "multiple",
        "location": "in",
        "orientation": "auto"
    },
    "inputData": {
        "choice": {
            "maxSelectable": 2,
            "minSelectable": 1,
            "visibilityAfterSubmit": "hide",
            "modeBeforeSubmit": "inputBlock",
            "submit": [
                {
                    "type": "chat_text",
                    "text": "Send"
                }
            ],
            "list": [
                {
                    "command": "opt_39d344d2b8e708",
                    "content": [
                        {
                            "type": "chat_text",
                            "text": "multi choice text 1"
                        }
                    ],
                    "interaction": {
                        "action": "cmd_step",
                        "type": "send_message",
                        "content": [
                            {
                                "type": "chat_text",
                                "text": "multi choice text 1"
                            }
                        ]
                    }
                },
                {
                    "command": "opt_a33115f27483f",
                    "content": [
                        {
                            "type": "chat_text",
                            "text": "multi choice text 2"
                        }
                    ],
                    "interaction": {
                        "action": "cmd_step",
                        "type": "send_message",
                        "content": [
                            {
                                "type": "chat_text",
                                "text": "multi choice text 2"
                            }
                        ]
                    }
                }
            ]
        }
    },
    "adamActions": [],
};
export const fakeXmppCreds = {
    user: "webclient",
    token: "webclient-private-token",
    thread: "6932c570-f526-4c77-b6c1-4b241e3597db",
};
